import { convertMillisecondsToSeconds, convertSecondsToTime } from '@core/format'
import { usePlayerTime } from '../hooks/usePlayerTime'

type TAudioPlaybackTimeContainerProps = {
    audioId: string
    /** Track length in milliseconds (from the audio model). */
    durationMs: number
}

export const AudioPlaybackTimeContainer = ({
    audioId,
    durationMs,
}: TAudioPlaybackTimeContainerProps) => {
    const totalTime = convertSecondsToTime(convertMillisecondsToSeconds(durationMs))
    const currentTime = usePlayerTime(audioId)
    const playbackTime = convertSecondsToTime(currentTime)

    return (
        <span>
            {playbackTime}-{totalTime}
        </span>
    )
}
